import  RightIcon from "./right-chevron.png"
import  ProfileIcon from "./profile.png"
import Options from "./options.png";
import Draggable from "./draggable.png";
import DeleteRed from "./delete-red.png";
import Hamburger_icon from "./hamburger-icon.svg";
import Hamburger_icon_black from "./hamburger-icon-black.svg";
import profile_img from "./profile-img.svg";
import Edit from "./edit.png";
import Close from "./close.png";

export default {
  RightIcon,
  ProfileIcon,
  Options,
  Draggable,
  DeleteRed,
  Hamburger_icon,
  profile_img,
  Edit,
  Close,
  Hamburger_icon_black,
};